// components/CurrentInvestmentForm.js
import React, { useEffect, useState } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAppContext } from '../context/AppContext';

function Equity() {
  const { state, actions } = useAppContext();
  const [value,setValues] = useState({
    stocks: state.stocks || '',
    unlisted: state.unlisted || '',
    pms: state.pms || '',
  });

  useEffect(() => {
    setValues({
      stocks: state.stocks || '',
      unlisted: state.unlisted || '',
      pms: state.pms || '',
    });
  }, [state.stocks, state.unlisted, state.pms])
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };


  return (
    <Box>
      <CardContent>
      <Box sx={{ mb: 2}}>
      <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Indian Equities
          </Typography>
        <Typography variant="body1" component="h2" gutterBottom>
         Direct Stocks
        </Typography>
      
          <TextField
            //label="Stocks"
            placeholder='total value of listed stocks'
            value={formatNumber(value.stocks)}
            onChange={handleChange('stocks')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
        PMS & AIF
        </Typography>
        
          <TextField
            //label="PMS"
            placeholder='total holding in PMS & AIF'
            value={formatNumber(value.pms)}
            onChange={handleChange('pms')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
        Unlisted Stocks, ESOP 
        </Typography>
        

          <TextField
            //label="ESOP/ RSU/ Unlisted shares"
            placeholder='total value of unlisted stocks'
            value={formatNumber(value.unlisted)}
            onChange={handleChange('unlisted')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        
        {/* <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
         AIF
        </Typography>
        
          <TextField
            //label="AIF"
            placeholder='total holdings in AIF'
            value={value.aif ? formatNumber(value.aif) : ''}
            onChange={handleChange('aif')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box> */}
      </CardContent>
</Box>
  );

}

export default Equity;